import { render, staticRenderFns } from "./Documentation.vue?vue&type=template&id=79d54ec3"
import script from "./Documentation.vue?vue&type=script&lang=js"
export * from "./Documentation.vue?vue&type=script&lang=js"
import style0 from "./Documentation.vue?vue&type=style&index=0&id=79d54ec3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports